package com.ives.modules.roi;

class ROIData {
	public static inline var TYPE:String = 'ROI';
	public static inline var NEW:String = 'NEW';
	public static inline var SHOW:String = 'SHOW';
	public static inline var HIDE:String = 'HIDE';

	public var action:String;
	public var imageId:String;
	public var description:String;
	public var type:String = TYPE;
	public var points:Array<Float>;

	public function new(action:String, imageId:String, description:String, points:Array<Float>) {
		this.imageId = imageId;
		this.action = action;
		this.description = description;
		this.points = points;
	}
}
